import React, { useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import style from '../style.module.css';

const MoveButton = ({ isDragging, dragHandleProps }) => {
  const buttonRef = React.useRef();

  useEffect(() => {
    if (isDragging && buttonRef.current) {
      ReactTooltip.hide(buttonRef.current);
    }
  }, [isDragging]);

  return (
    <button
      {...dragHandleProps}
      type="button"
      className={classnames('material-icons', style.moveButton)}
      data-tip="Move environment"
      aria-label="Move environment"
      ref={buttonRef}
      style={{ background: 'none', border: 'none', cursor: 'grab', padding: '4px' }}
    >
      drag_indicator
    </button>
  );
};

MoveButton.propTypes = {
  isDragging: PropTypes.bool.isRequired,
  dragHandleProps: PropTypes.object.isRequired
};

export default MoveButton;